import { useCallback, useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';

const token =
   process.env.REACT_APP_MAPBOX_ACCESS_TOKEN ||
   process.env.REACT_APP_MAPBOX_TOKEN ||
   'pk.eyJ1IjoidHJpcGFwcC1kZW1vIiwiYSI6ImNrcjRhNW80dzJmaWMycG84aXQ0em05MmoifQ.ivkXbfZOwJ1I3fKVE8K5fw'; // Fallback token
mapboxgl.accessToken =
   'pk.eyJ1IjoiMjA0NXB1Ymxpc2hpbmciLCJhIjoiY203cWlvcmx6MHh2bDJsb3B6YXFleWVtbyJ9.Nj8MPh5WkVi2PYzYcbpVAA'; //token;

const useMap = () => {
   const [markers,setMarker] = useState<mapboxgl.Marker[]>([]);
   const mapContainer = useRef<HTMLDivElement | null>(null);
   const [bounds,setBounds] = useState<any>(new mapboxgl.LngLatBounds());
   const [map,setMap] = useState<mapboxgl.Map | null>(null);
    const [isLoading,setIsLoading] = useState(false);
    
        

   const resetBounds = () => {
     setBounds(new mapboxgl.LngLatBounds())
   };

   const boundsIsEmpty = useCallback(() => {
      return bounds.isEmpty();
   }, []);

    const extendBounds = (coordinates: number[]) => {
        if (bounds) {
            bounds.extend(coordinates);
       }
     
   };

   const initMap = async () => {
       try {
          if (map) {
             return;
          }

          setIsLoading(true);

          if (mapContainer.current) {
             mapContainer.current.style.width = '100%';
             mapContainer.current.style.height = '100%';
             mapContainer.current.style.position = 'relative';
          }

          const _map = new mapboxgl.Map({
             container: mapContainer.current as HTMLElement,
             style: 'mapbox://styles/mapbox/streets-v11',
             center: [0, 20], // Center on world
             zoom: 2,
             preserveDrawingBuffer: true,
             minZoom: 1.5,
             maxBounds: [
                [-180, -85], // Southwest coordinates
                [180, 85], // Northeast coordinates
             ],
          });

          _map.addControl(new mapboxgl.NavigationControl(), 'top-right');
          setMap(_map);

          resetBounds();
       } catch (error) {

          throw error;
       } finally {
          setIsLoading(false);
       }
   };

   const clearMarkers = () => {
      if (markers.length > 0) {
         markers.forEach((marker) => marker.remove());
          setMarker([])
          
      }
   };

   const createMapMarker = (options: { [key: string]: any }) => {
      const newMarker = new mapboxgl.Marker({
         
         anchor: 'bottom',
         ...options,
      });
    setMarker((prev:any) => [...prev,newMarker]);
      return newMarker;
   };

  


    useEffect(() => {
        if (!map) {
              initMap();
          }
         

          return () => {
             if (map) {
                 setMap(null);
             }
          };
      }, [mapContainer.current]);
    

   
    
    return {
       initMap,
       resetMap: () => {
          setMap(null)
       },
       map: map,
       mapLoaded:isLoading,
       mapContainer,
       extendBounds,
       resetBounds,
       boundsIsEmpty,
       clearMarkers,
       createMapMarker,
    };
};

export default useMap;
